exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".recommended-product-line .recommended-product-line__product {\n  display: inline-block;\n  width: 50%;\n  padding-bottom: 0.5em; }\n\n.recommended-product-line button {\n  vertical-align: text-bottom; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./src/scenes/Products/ProductDetail/RecommendedProductsTab/ProductLine/style.scss
// module id = ../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./src/scenes/Products/ProductDetail/RecommendedProductsTab/ProductLine/style.scss
// module chunks = 0